import React from 'react';
import { Route, Switch, Link, withRouter, Redirect } from 'react-router-dom';
import axios from 'axios';
import FrontPage from './components/frontPage.component';
import Signup from './components/signup.component';
import Assets from './components/assets.component';  
import Login from './components/login.component';
import ForgotPassword from './components/forgotPassword.component';
import Inactive from './components/inactive.component';
import FormBuilder from './components/formBuilder';
import Dashboard from './components/dashboard.component';
import AdminForms from './components/adminForms.component'; 
import AdminUsers from './components/adminUsers.component'; 
import Organization from './components/organization.component';
import Thankyou from './components/thankyou.component'; 
import Form from './components/form.component'; 
import { connect } from 'react-redux';
import logo from './images/logow.png';

class App extends React.Component {
	constructor(props) {
		super(props);
		this.handleLogin = this.handleLogin.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
		this.handleSignup = this.handleSignup.bind(this); 
		
		this.state = {
			APIURL: "https://formsadmin.adapticts.com", //Production 
			url: "https://forms.adapticts.com", //Production
			// APIURL: "https://devformsadmin.adapticts.com", //Development
			// url: "https://devforms.adapticts.com", //Development
			isLoggedIn: false,
			loginMessage: '',
			username: '',
			password: '',
			accessToken: '',
			email: '',
			userId: 0,
			roles: '',
			status: '',
			showRedirect: false,
			redirect: '',
			editFormData: null,
			formLogo: ''
		};

		let formcode = this.props.location.pathname.replace("/form/", ""); 
		
		// temp over ride for SCU form 
		// if (formcode === 'QD3ccF085KKlHccDLNrm6xae3rCajW'){
		// 	window.location.href="https://www.shrevecu.org/connect/"; 
		// }
	}

	componentDidMount(){
		let x = JSON.parse(localStorage.getItem("state")); 
		let formcode = this.props.location.pathname.replace("/form/", "") || null;

		if (x === null){

		}else{
			if (formcode === null){
				this.setState({
					APIURL: x.APIURL,
					isLoggedIn: x.isLoggedIn,
					username: x.username,
					password: x.password,
					accessToken: x.accessToken,
					email: x.email,
					userId: x.userId,
					roles: x.roles,
					status: x.status,
					showRedirect: x.showRedirect,
					redirect: x.redirect,
					editFormData: x.editFormData,
					formLogo: x.formLogo
				}); 
			}
		}	
	}

	redirect = (location) => {
		this.setState({ redirect: location });
		console.log(this.state); 
	}

	redirectForEdit = (data) => {
		this.setState({ 
			editFormData: data,
		});
	}

	redirectForNew = () => {
		this.setState({
			redirect: '/formbuilder',
			editFormData: null
		});
	}

	handleUsernameChange = (event) => {
		this.setState({ username: event.target.value });
	}

	handlePasswordChange = (event) => {
		this.setState({ password: event.target.value });
	}

	handleLogin() {
		axios.post(this.state.APIURL + '/api/auth/signin', {
			username: this.state.username,
			password: this.state.password
		}).then(res => {
			if (res.status === 200) {
				this.props.dispatch({
					type: 'IS_LOGGED_IN',
					isLoggedIn: true,
					accessToken: res.data.accessToken,
					email: res.data.email,
					userId: res.data.id,
					username: this.state.username
				});
				
				if (res.data.status === 'inactive'){
					this.setState({
						isLoggedIn: false,
						showRedirect: true,
						redirect: '/inactive'
					}); 
				}else{
					let role; 
					if (res.data.roles.includes("ROLE_ADMIN")){
						role = "admin";
					}else{
						role = "user"; 
					}
					
					this.setState({
						accessToken: res.data.accessToken,
						email: res.data.email,
						userId: res.data.id,
						roles: role,
						status: res.data.status,
						isLoggedIn: true,
						redirect: '/dashboard'
					});

					localStorage.setItem("state", JSON.stringify(this.state)); 
				}
			}
		}).catch(err => {
			this.setState({
				loginMessage: err.response.data.message
			}) 
		})
	}

	handleLogout() {
		this.setState({
			accessToken: '',
			email: '',
			isLoggedIn: false,
			showRedirect: true,
			redirect: '/'
		});

		localStorage.removeItem("state"); 
	}

	handleSignup() {
		this.setState({
			redirect: '/signup'
		});
	}

	setLogoUrl = (url) => {
		this.setState({
			formLogo: url
		})
	}



	render() {
	
		let account, nav, spacer, redirect, role, adminLinks;  

		if (this.state.showRedirect){
			redirect = <Redirect to={ this.state.redirect }></Redirect>
		}


		if (this.state.isLoggedIn){
			if (this.state.roles === 'admin'){
			account = <div className="btn-group">
						<button type="button" className="btn btn-outline-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							Account
						</button>
						<div className="dropdown-menu dropdown-menu-right">
							<Link to='/account' className="dropdown-item">Account</Link>
							<div className="dropdown-divider"></div>
							<Link to='/adminforms' className="dropdown-item">Forms Administration</Link>
							<Link to='/adminusers' className="dropdown-item">User Administration</Link>
							<div className="dropdown-divider"></div>
							<a className="dropdown-item" href="#" onClick={ this.handleLogout }>Logout</a>
						</div>
					</div>;

			}else{
			account = <div className="btn-group">
						<button type="button" className="btn btn-outline-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							Account
						</button>
						<div className="dropdown-menu dropdown-menu-right">
							<Link to='/account' className="dropdown-item">Account</Link>
							<div className="dropdown-divider"></div>
							<a className="dropdown-item" href="#" onClick={ this.handleLogout }>Logout</a>
						</div>
					</div>;
			}

			nav = <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-primary" style={{ background: '-webkit-linear-gradient(180deg, #00e380, #0099ee)'}}>
				<Link className="navbar-brand" to="/">
					<img src={logo} className="" alt="Adapticts.com" />
				</Link>
				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarNav">
					<ul className="navbar-nav">
						<li className="nav-item">
							<Link className="nav-link" to="/dashboard">Dashboard</Link>
						</li>
						<li className="nav-item">
							<Link className="nav-link" to="/assets">Assets</Link>
						</li>
					</ul>
				</div>
				{account}
			</nav>;

			spacer = <div style={{ height: "120px" }}></div>
			
			redirect = <Redirect to={ this.state.redirect }></Redirect>
			
		}else{
			spacer = <div style={{ height: "14px" }}></div>
		}

		return (
			<div>
				{ nav }
				{ spacer }
				{ redirect }
				<div className="container-fluid">
					
					<Switch>

						<Route path="/form/:formcode">
							<Form 
								apiurl={this.state.APIURL}
								handleRedirect={this.redirect}
							></Form>
						</Route>

						<Route path="/thankyou">
							<Thankyou
								redirect={this.state.redirect}
							></Thankyou>
						</Route>

						<Route path="/assets">
							<Assets 
								userdata={this.state}
								apiurl={this.state.APIURL}></Assets>
						</Route>

						<Route exact path="/account">
						</Route>
						<Route exact path="/adminforms">
							<AdminForms 
								apiurl={this.state.APIURL}
								userdata={ this.state }
							></AdminForms>
						</Route>
						<Route exact path="/adminusers">
							<AdminUsers 
								apiurl={this.state.APIURL}
								userdata={ this.state }
							></AdminUsers>
						</Route>
						<Route exact path="/dashboard">
							<Dashboard
								apiurl={ this.state.APIURL }
								url={ this.state.url }
								userdata={ this.state } 
								redirectForNew={ this.redirectForNew }
								redirectForEdit={ this.redirectForEdit } 
								redirect={ this.redirect } />
						</Route>
						<Route path="/formBuilder">
							<FormBuilder 
								apiurl={ this.state.APIURL } 
								userdata={ this.state } 
								redirect={ this.redirect }/>
						</Route>
						<Route path="/organization">
							<Organization
								apiurl={this.state.APIURL} >
							</Organization>
						</Route>
						<Route path="/signup">
							<Signup
								userdata={this.state}
								apiurl={this.state.APIURL}
							></Signup>
						</Route>
						<Route path="/login">
							<Login
								handleUsernameChange={ this.handleUsernameChange }
								handlePasswordChange={ this.handlePasswordChange }
								login={ this.handleLogin }
								signup={ this.handleSignup }
								loginMessage={ this.state.loginMessage }
							/>
						</Route>
						<Route path="/inactive">
							<Inactive></Inactive>
						</Route>
						<Route path="/forgotpassword">
							<ForgotPassword></ForgotPassword>
						</Route>
						<Route exact path="/">
							<FrontPage></FrontPage>
						</Route>
					</Switch>
					
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return state;
}

const mapDispatchToProps = dispatch => {
	return {
		dispatch
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(App))
